import { createFileRoute } from "@tanstack/react-router";
import { SubscriptionSuccess } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/subscription/success-quarterly")({
  head: () => seoHead({
    title: "Payment Successful",
    description: "Your LeadXkids quarterly membership is now active.",
    noindex: true,
  }),
  component: () => <SubscriptionSuccess variant="quarterly" />,
});
